import React from 'react'
import Grid from '@material-ui/core/Grid';
import DatePicker from 'antd/es/date-picker'
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import styled from 'styled-components';
import excelIcon from '../../assets/img/ExcelIcon.svg'
import { useTranslation } from 'react-i18next'

const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: '5px',
    borderBottomRightRadius: '5px',
    height: '32px',
    width: '32px',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
}

const LegendAP = {
    marginTop: '-0.5em',
    marginBottom: '0.5em',
    color: 'red',
    fontSize: '17px',
    fontWeight: '600'
}

const TableFilterComponent = ({ filterText, onFilter, onClear, onStartDateChange, onEndDateChange, onClickSearch, onExport, styles, isSubHeader, textSubHeader }) => {
    const { t } = useTranslation();
    return (
        <>
            <Grid container spacing={1}>
                {
                    isSubHeader && isSubHeader === true && (
                        <Grid container item xs={12}>
                            <p style={LegendAP}>{textSubHeader}</p>
                        </Grid>
                    )
                }
                <Grid container item xs={12}>
                    <Grid container item xs={8} spacing={3}>
                        <Grid item xs={3}>
                            <DatePicker style={{ width: '170px' }} onChange={onStartDateChange} placeholder={t('common.from')} />
                        </Grid>
                        <Grid item xs={3}>
                            <DatePicker style={{ width: '170px' }} onChange={onEndDateChange} placeholder={t('common.toDate')} />
                        </Grid>
                        <Grid item xs={2}>
                            <Button type="button" variant="contained" onClick={onClickSearch} color="primary">{t('common.search')}</Button>
                        </Grid>
                        <Grid item xs={4}>
                            <Button type="button" variant="outlined" onClick={e => onExport(e.target.value)}>
                                {t('commonMessages.dlExcel')} <img src={excelIcon} alt="excel-icon" width="24" height="24" />
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid item xs={4} className={styles}>
                        <ButtonGroup disableElevation variant="contained">
                            <TextField id="search" type="text" placeholder={t('common.search')} aria-label="Search Input" value={filterText} onChange={onFilter} />
                            <Button type="button" variant="contained" onClick={onClear} color="primary" style={ClearButton}>X</Button>
                        </ButtonGroup>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default TableFilterComponent
